import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from 'moment';
import { formatNumber } from '../../../../../../utility/helper';
import { FaArrowLeft, FaArrowRight, FaEdit, FaRegTrashAlt } from 'react-icons/fa';

const MovementComponent = ({ viewTransaction, viewFutureTransaction, handleOptionSelect, confirmDelete, setLimit, limit, setPage, page }) => {
  const [loading, setLoading] = useState(false);

  const onPageChange = (e) => {
    setPage(e.page);
    setLimit(e.rows);
  };


  const reasonTemplate = (rowData) => {
    return rowData.reason ? rowData.reason : "-";
  };

  const currencyTemplate = (rowData) => {
    return rowData.currency ? rowData.currency : "-";
  };

  

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <button disabled={rowData?.is_initial} className={`focus:outline-none mr-2 ${rowData?.is_initial ? 'text-gray-400 cursor-not-allowed' : 'text-secondary'
          }`} >
          <FaEdit
            onClick={() => {
              if (!rowData?.is_default) {
                handleOptionSelect(rowData.type, "Update", rowData);
              }
            }}
          />
        </button>
        <button disabled={rowData?.is_initial} className={`focus:outline-none ${rowData?.is_initial ? 'text-gray-400 cursor-not-allowed' : 'text-expense'
          }`} >
          <FaRegTrashAlt
            onClick={() => {
              if (!rowData?.is_default) {
                confirmDelete(rowData);
              }
            }}
          />
        </button>
      </div>
    );
  };

  const dateTemplate = (rowData) => {
    return (moment(rowData.date).format('DD-MM-YYYY'));
  };

  const cashTemplate = (rowData) => {
    const cashValue = rowData.amount ? rowData.amount : 0;
    const type = rowData.type?.toUpperCase();
    const formattedValue = formatNumber(cashValue);

    return (type === "SELL" || type === "EXPENSE")
      ? <div className='text-expense'>{cashValue !== 0 ? `-${formattedValue}` : formattedValue}</div>
      : <div className='text-secondary'>{formattedValue}</div>;
  };


  return (
    <div>
      <DataTable
        value={viewTransaction.transactions}
        className="transaction mt-3"
        sortMode="multiple"
        // paginator
        rows={limit}
        totalRecords={viewTransaction.total}
        first={page * limit}
        onPage={onPageChange}
        loading={loading}
        emptyMessage="No data available"
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
      >
        <Column field="date" header="Date" body={dateTemplate} style={{ width: '10%' }} />
        <Column field="type" header="Transaction Type" style={{ width: '13%' }} />
        <Column field="remark" header="Reason" body={reasonTemplate} style={{ width: '10%' }} />
        <Column field="currency" header="Currency" body={currencyTemplate} style={{ width: '10%' }} />
        <Column field="amount" header="Transaction Amount" body={cashTemplate} align="right" style={{ width: '16%' }} />
        <Column field="Action" header="Action" body={actionBodyTemplate} style={{ width: "15%" }} align="right" />
      </DataTable>
      {viewTransaction?.total > limit && (
        <div className={`flex gap-3 items-center px-3 pt-10 text-secondary ${page > 0 ? 'justify-between' : 'justify-end'}`}>
          {page > 0 && (
            <button
              onClick={() => {
                setPage((prevPage) => prevPage - 1);
              }}
              className="flex items-center gap-1"
            >
              <FaArrowLeft />
              View Previous
            </button>
          )}
          <button
            onClick={() => {
              const maxPage = Math.ceil(viewTransaction?.total / limit) - 1;
              if (page < maxPage) {
                setPage((prevPage) => prevPage + 1);
              }
            }}
            className="flex items-center gap-1"
          >
            View Next
            <FaArrowRight />
          </button>
        </div>
      )}
    </div>
  );
};

export default MovementComponent;
